import $ from "jquery";

function fillWithBaseUrlIfBlank(value: string): string {
    if (value) {
        return value;
    }

    // Retrieve the base URL from the "base" tag
    const baseEls = document?.getElementsByTagName("base");
    return baseEls?.[0]?.getAttribute("href");
}

function drawButton(this: JQueryUI.WidgetCommonProperties): void {
    // Perform the default behaviour
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (this as any)._super();
    // Now fix the ARIA roles, which are incorrect in selectmenu
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const button: JQuery = (this as any).button;
    if (button) {
        button.attr("role", "button");
        button.attr("aria-haspopup", "listbox");
        button.removeAttr("aria-autocomplete");
    }
}

function buildFlagImg(flagUrl: string, label: string): JQuery {
    // noinspection RequiredAttributes,HtmlRequiredAltAttribute
    return $("<img/>", {
        "class": "flag-image",
        src: flagUrl,
        // FUTURE: Should be localized
        alt: "icon for " + label,
    });
}

function renderButtonItem(
    this: JQueryUI.WidgetCommonProperties,
    item: JQueryUISelectMenuRenderButtonItemData,
): JQuery {
    const buttonItem = $("<span></span>", {
        "class": "ui-selectmenu-text",
        title: fillWithBaseUrlIfBlank(item.value),
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (this as any)._setText(buttonItem, item.label);
    const flagWrapper = $("<div></div>", {
        "class": "flag-wrapper",
    });
    buttonItem.prepend(flagWrapper);
    const flagUrl = item.element.attr("data-flag-url");
    if (flagUrl) {
        flagWrapper.append(buildFlagImg(flagUrl, item.label));
    }
    return buttonItem;
}

function renderItem(
    ul: JQuery,
    item: JQueryUISelectMenuRenderItemData,
): JQuery {
    const li = $("<li></li>");
    if (item.disabled) {
        li.addClass("ui-state-disabled");
    }
    const wrapper = $("<div></div>", {
        text: item.label,
        title: fillWithBaseUrlIfBlank(item.value),
    });
    const flagWrapper = $("<div></div>", {
        "class": "flag-wrapper",
    });
    wrapper.prepend(flagWrapper);
    const flagUrl = item.element.attr("data-flag-url");
    if (flagUrl) {
        flagWrapper.append(buildFlagImg(flagUrl, item.label));
    }
    return li.append(wrapper).appendTo(ul);
}

export function registerServerSelectMenuWidget(): void {
    // Create a custom select menu control
    $.widget("exclaim.serverSelectMenu", $.ui.selectmenu, {
        _drawButton: drawButton,
        _renderButtonItem: renderButtonItem,
        _renderItem: renderItem,
    });
}
